import { useEffect, useRef, useState } from "react";
import { Music, Pause } from "lucide-react";

const VIDEO_ID = "l5shyQIUMjA";

export const MusicPlayer = () => {
  const playerRef = useRef(null);
  const startedRef = useRef(false);
  const [ready, setReady] = useState(false);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const init = () => {
      playerRef.current = new window.YT.Player("nalura-music-player", {
        videoId: VIDEO_ID,
        playerVars: { autoplay: 0, controls: 0, loop: 1, playlist: VIDEO_ID },
        events: {
          onReady: (e) => {
            e.target.setVolume(35);
            setReady(true);
          },
          onStateChange: (e) => setPlaying(e.data === window.YT.PlayerState.PLAYING),
        },
      });
    };
    if (window.YT && window.YT.Player) {
      init();
    } else {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
      window.onYouTubeIframeAPIReady = init;
    }
    return () => {
      try { playerRef.current?.destroy(); } catch {}
    };
  }, []);

  useEffect(() => {
    if (!ready) return;
    const start = () => {
      if (!startedRef.current) {
        startedRef.current = true;
        try { playerRef.current.playVideo(); } catch {}
      }
      window.removeEventListener("pointerdown", start);
      window.removeEventListener("keydown", start);
    };
    window.addEventListener("pointerdown", start);
    window.addEventListener("keydown", start);
    return () => {
      window.removeEventListener("pointerdown", start);
      window.removeEventListener("keydown", start);
    };
  }, [ready]);

  const toggle = () => {
    if (!playerRef.current) return;
    startedRef.current = true;
    try {
      playing ? playerRef.current.pauseVideo() : playerRef.current.playVideo();
    } catch {}
  };

  return (
    <>
      <div aria-hidden="true" style={{ position: "fixed", left: "-9999px", top: 0, width: 1, height: 1, overflow: "hidden" }}>
        <div id="nalura-music-player" />
      </div>
      <button
        data-testid="music-toggle"
        onClick={toggle}
        aria-label={playing ? "Jeda musik relaksasi" : "Putar musik relaksasi"}
        title={playing ? "Jeda musik relaksasi" : "Putar musik relaksasi"}
        className="fixed bottom-6 right-6 z-50 inline-flex items-center gap-3 bg-[#211B10] text-[#EACB6B] border border-[#A67C1E]/40 px-4 py-3 shadow-lg hover:bg-[#3a3020] transition-colors duration-300 group"
      >
        {playing ? (
          <>
            <span className="flex items-end gap-[3px] h-4" aria-hidden="true">
              <span className="w-[3px] bg-[#EACB6B] eq-bar" style={{ animationDelay: "0ms" }} />
              <span className="w-[3px] bg-[#EACB6B] eq-bar" style={{ animationDelay: "180ms" }} />
              <span className="w-[3px] bg-[#EACB6B] eq-bar" style={{ animationDelay: "360ms" }} />
            </span>
            <Pause className="w-4 h-4" />
          </>
        ) : (
          <Music className="w-4 h-4" />
        )}
        <span className="hidden sm:block font-mono text-[9px] uppercase tracking-[0.2em]">
          {playing ? "Musik Zen" : "Putar Musik"}
        </span>
      </button>
    </>
  );
};
